import { mapQuery } from 'utils/query';
import { Details } from 'components/details';
import { useProfitAndLossesQuery } from 'store/api/event';
import { EventProfitAndLosses } from 'components/event-profit-and-losses';

import { ProfitAndLossesProps } from './types';

export const ProfitAndLosses = ({ event }: ProfitAndLossesProps) => {
  const { data: profitAndLosses, ...props } = useProfitAndLossesQuery(
    String(event.id),
    { skip: !event.id }
  );

  return (
    <Details {...mapQuery(props)}>
      <EventProfitAndLosses event={event} profitAndLosses={profitAndLosses} />
    </Details>
  );
};
